import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { initState as initMaterialState } from "@reducers/selectors/material";
import { APP_TYPES } from "@config";

export default {
  depth: initMaterialState[APP_TYPES.GENERAL_CALCULATION].concrete.thicknessOfConcrete,
  padding: {
    C1x: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.edgeDistance.c1x, // Null = ∞ char in UI
    C2x: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.edgeDistance.c2x,
    C1y: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.edgeDistance.c1y,
    C2y: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.edgeDistance.c2y
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/ground/defaults/generalCalculation.js